import { useMemo } from 'react';
import { Text } from '@chakra-ui/react';
import { User } from 'lucide-react';
import { t } from '@lingui/core/macro';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export default function AssessorFilter({ maxSelected }: { maxSelected?: number }) {
  const { updateFilters, filters } = useFiltersContext();
  const { data: assessors } = trpcAdmin.users.all.useQuery();

  const options = useMemo(() => {
    const mapped = (assessors ?? [])
      .map(({ id, first_name, last_name }) => ({
        id: id,
        value: id,
        label: `${first_name} ${last_name ?? ''}`.trim(),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    return [
      {
        id: 'unassigned',
        value: 'unassigned',
        label: 'Unassigned',
        element: (
          <Text fontSize="sm" fontStyle="italic" color="fg.muted">
            Unassigned
          </Text>
        ),
      },
      ...mapped,
    ];
  }, [assessors]);

  const selected = filters.assessorIds ?? [];

  return (
    <MultipleChoiceFilter
      items={options}
      label={t`Assessor`}
      name="assessorIds"
      value={selected.join(',')}
      onFilterChange={({ assessorIds }) => updateFilters({ assessorIds })}
      onlyUpdateOnChange
      variant="ghost"
      leftIcon={<User size={iconSize.md} />}
      rightIcon={undefined}
      maxSelected={maxSelected}
    />
  );
}
